export const common = {
  // Navbar
  nav_home: "Home",
  nav_services: "Servizi",
  nav_process: "Processo",
  nav_references: "Referenze",
  nav_about: "Chi Siamo",
  nav_contact: "Contatti",
  nav_cta: "Richiedi una Consulenza",

  // Hero
  hero_title: "Consulenza Territoriale e Sviluppo in Sicilia",
  hero_subtitle:
    "Analisi delle pendenze, studi di fattibilità e due diligence per supportare decisioni informate in materia di uso del suolo e sviluppo.",
  hero_feature1: "Analisi Tecnica",
  hero_feature2: "Documentazione Chiara",
  hero_feature3: "Contesto Locale in Sicilia",

  // Services
  services_title: "I Nostri Servizi",
  services_subtitle:
    "Servizi completi di consulenza territoriale su misura per supportare progetti di sviluppo in tutta la Sicilia.",

  service1_title: "Consulenza Territoriale",
  service1_desc:
    "Guida strategica per l'acquisizione di terreni e la pianificazione dello sviluppo.",
  service1_point1: "Selezione e valutazione del sito",
  service1_point2: "Valutazione del potenziale di sviluppo",

  service2_title: "Analisi delle Pendenze",
  service2_desc:
    "Valutazione topografica dettagliata per supportare la pianificazione della costruzione.",
  service2_point1: "Mappatura e classificazione dei gradienti di pendenza",
  service2_point2: "Identificazione di stabilità e vincoli",

  service3_title: "Analisi di Fattibilità",
  service3_desc:
    "Valutazione completa della fattibilità del progetto e dei vincoli.",
  service3_point1: "Revisione tecnica e normativa",
  service3_point2: "Valutazione di rischi e opportunità",

  service4_title: "Due Diligence",
  service4_desc:
    "Valutazione approfondita delle caratteristiche del terreno e della conformità.",
  service4_point1: "Verifica del titolo e della zonizzazione",
  service4_point2: "Revisione dei vincoli ambientali e fisici",

  service5_title: "Supporto per Permessi",
  service5_desc:
    "Guida attraverso i requisiti normativi e i processi di approvazione.",
  service5_point1: "Assistenza nella preparazione della documentazione",
  service5_point2: "Chiarimento del percorso normativo",

  service6_title: "GIS / Mappatura",
  service6_desc:
    "Analisi e visualizzazione di dati spaziali per supportare decisioni informate.",
  service6_point1: "Mappatura personalizzata e analisi stratificata",
  service6_point2: "Integrazione dei dati e reportistica",

  // Process
  process_title: "Il Nostro Processo",
  process_subtitle:
    "Un approccio strutturato focalizzato sulla chiarezza e sul supporto decisionale in ogni fase.",

  process1_title: "Selezione del Sito",
  process1_desc:
    "Revisione iniziale del sito, valutazione della posizione e identificazione dei vincoli di alto livello.",

  process2_title: "Analisi Tecnica",
  process2_desc:
    "Valutazione tecnica dettagliata che include analisi delle pendenze, revisione della fattibilità e valutazione basata su GIS.",

  process3_title: "Processo di Permessi",
  process3_desc:
    "Revisione normativa, chiarimento del percorso per i permessi e supporto alla documentazione.",

  // Case Studies
  cases_title: "Panoramica dei Servizi di Riferimento",
  cases_subtitle: "Tipologie di analisi tipiche e ambito dei servizi.",

  case1_title: "Screening Territoriale per Potenziale di Sviluppo",
  case1_desc:
    "Valutazione tecnica di più appezzamenti per identificare siti adatti allo sviluppo residenziale.",
  case1_scope:
    "Analisi topografica, revisione della zonizzazione, valutazione dell'accesso e mappatura preliminare dei vincoli.",
  case1_deliverables:
    "Analisi comparativa del sito con documentazione tecnica delle caratteristiche e dei vincoli del sito.",

  case2_title: "Revisione dei Vincoli di Pendenza per la Pianificazione del Sito",
  case2_desc:
    "Valutazione delle caratteristiche del terreno e delle limitazioni per i siti di sviluppo proposti.",
  case2_scope:
    "Analisi dettagliata delle pendenze, stima dei volumi di scavo e riporto e individuazione delle aree edificabili.",
  case2_deliverables:
    "Documentazione tecnica delle caratteristiche del terreno, considerazioni di livellamento e requisiti infrastrutturali.",

  case3_title: "Due Diligence per Acquisizione Territoriale",
  case3_desc:
    "Revisione completa delle caratteristiche del terreno e della conformità normativa per la valutazione dell'acquisizione.",
  case3_scope:
    "Verifica del titolo, controllo della conformità normativa, screening ambientale e valutazione fisica del sito.",
  case3_deliverables:
    "Rapporto tecnico che documenta le caratteristiche del sito, lo stato normativo e i vincoli identificati.",

  case_scope_label: "Ambito Tipico:",
  case_deliverables_label: "Risultati:",

  // About
  about_title: "Chi è Service Immobil Sicily",
  about_p1:
    "Service Immobil Sicily fornisce servizi di consulenza territoriale focalizzati sull'analisi tecnica e sul supporto decisionale per progetti di sviluppo in tutta la Sicilia.",
  about_p2:
    "Il nostro approccio si basa sulla valutazione basata sui dati, combinando tecnologia GIS, valutazione sul campo e conoscenza normativa per fornire informazioni chiare e attuabili.",
  about_p3:
    "Enfatizziamo la reportistica trasparente e le raccomandazioni pratiche, aiutando i clienti a comprendere le caratteristiche del sito, i vincoli e le opportunità per prendere decisioni informate su terreni e sviluppo.",
  about_feature1: "Approccio Basato sui Dati",
  about_feature2: "Reportistica Trasparente",
  about_feature3: "Raccomandazioni Pratiche",

  // Contact
  contact_title: "Contattaci",
  contact_subtitle:
    "Pronto a discutere il tuo progetto di sviluppo? Contattaci per richiedere una consulenza.",
  contact_heading: "Discutiamo del Tuo Progetto",
  contact_intro:
    "Che tu stia valutando un sito, pianificando uno sviluppo o necessiti di analisi tecniche, siamo qui per aiutarti. Contattaci per discutere le tue esigenze e i prossimi passi migliori.",
  contact_email_label: "Email",

  form_fullname: "Nome Completo",
  form_company: "Azienda",
  form_email: "Email",
  form_phone: "Telefono",
  form_service: "Servizio di Interesse",
  form_location: "Località / Area",
  form_details: "Dettagli del Progetto",
  form_select_service: "Seleziona un servizio",
  form_submit: "Invia Messaggio",
  form_submitting: "Invio in corso...",
  form_success:
    "Grazie! Il tuo messaggio è stato inviato con successo. Ti risponderemo presto.",
  form_error:
    "Spiacenti, si è verificato un errore nell'invio del messaggio. Riprova o contattaci direttamente.",
  form_consent:
    "Inviando questo modulo, acconsenti alla raccolta e al trattamento delle tue informazioni allo scopo di rispondere alla tua richiesta.",
  form_required: "*",
  form_chars: "caratteri",

  placeholder_fullname: "Il tuo nome completo",
  placeholder_company: "Nome della tua azienda",
  placeholder_email: "tua.email@esempio.com",
  placeholder_phone: "+39 123 456 7890",
  placeholder_location: "Località del progetto in Sicilia",
  placeholder_details: "Breve descrizione del tuo progetto e delle tue esigenze",

  // Footer
  footer_desc:
    "Servizi professionali di consulenza territoriale in Sicilia, fornendo analisi tecniche e supporto decisionale per progetti di sviluppo.",
  footer_services: "Servizi",
  footer_company: "Azienda",
  footer_contact: "Contatti",
  footer_about: "Chi Siamo",
  footer_copyright: "Tutti i diritti riservati."
};

export default common;
